import { Button, Grid, Typography } from '@mui/material';
import { AppModels, AppState, CompanyAttrs, ContactAttrs, Lang, ProjectAttrs, hasErrors, projectPageSlice, saveModel } from 'cdx-common';
import { useSelector } from 'react-redux';
import { useToaster } from '../../libraries/Toaster';
import { appStore } from '../../store';
import { SuperSearchInput } from '../SuperSearchInput';
import { ExcelTabStructEditor } from '../excelparser/ExcelTabStructs';
import { LocationInput } from '../location/LocationInput';
import { UserSelect } from '../user/UserSelect';
import { ModelTextfield } from '../utils/ModelTextField';
import { PreviousProjectCodes } from './PreviousProjectsCodes';
import { ProjectData } from './ProjectData';
import { ProjectTestView } from './ProjectTestView';

export const ProjectParamters = () => {
    const project = useSelector((state: AppState) => state.projectPage.project);
    const { toast } = useToaster();

    const update = (p: Partial<ProjectAttrs>) => {
        appStore.dispatch(projectPageSlice.actions.updateProject(p));
    };

    const onSave = async () => {
        const response = await saveModel(AppModels.projects, project);
        update(response);
        if (!hasErrors(response)) {
            toast.success('Modification sauvegardées');
        } else {
            toast.error('Erreur lors de la sauvegarder');
        }
    };
    return <Grid container spacing={2}>
        <Grid item xs={12}>
            <ModelTextfield
                fullWidth
                model={project}
                modelType={AppModels.projects}
                row='name'
                onChange={event => update({ name: event.target.value })}
            />
        </Grid>
        <Grid item xs={12} sm={6}>
            <ModelTextfield
                fullWidth
                model={project}
                modelType={AppModels.projects}
                row='code'
                onChange={event => update({ code: event.target.value })}
            />
            <PreviousProjectCodes project={project} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <ModelTextfield
                fullWidth
                model={project}
                modelType={AppModels.projects}
                row='customerCode'
                onChange={event => update({ customerCode: event.target.value })}
            />
        </Grid>
        <Grid item xs={12} sm={6}>
            <SuperSearchInput
                filter={[AppModels.companies]}
                value={project.customerCompanyId ? { type: AppModels.companies, id: project.customerCompanyId } : undefined}
                onItemSelected={(_type: AppModels, _id: ModelId, data: CompanyAttrs) => {
                    update({ customerCompanyId: data.id });
                }}
                textfieldProps={{ label: Lang('labels.projects.customerCompanyId') }} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <SuperSearchInput
                filter={[AppModels.contacts]}
                value={project.mainContactId ? { type: AppModels.contacts, id: project.mainContactId } : undefined}
                onItemSelected={(_type: AppModels, _id: ModelId, data: ContactAttrs) => {
                    update({ mainContactId: data.id });
                }}
                textfieldProps={{ label: Lang('labels.projects.mainContactId') }} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <UserSelect
                label='Superviseur du chantier'
                value={project.onSiteSupervisorId ?? undefined}
                onChange={(event) => {
                    if (typeof event.target.value === 'number') {
                        update({ onSiteSupervisorId: event.target.value });
                    }
                }} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <LocationInput fullWidth label={Lang('labels.projects.locationId')} value={project.locationId} onChange={(locationId: ModelId | null) => { update({ locationId }); }} />
        </Grid>
        <Grid item xs={12}>
            <ProjectData projectId={project.id} />
        </Grid>
        <Grid item xs={12}>
            <Typography variant='h3'>Plans des étages</Typography>
            <ProjectTestView projectId={project.id} />
        </Grid>
        <Grid item xs={12}>
            <Button variant='contained' onClick={onSave}>Sauvegarder</Button>
        </Grid>
        <Grid item xs={12}>
            <ExcelTabStructEditor />
        </Grid>
    </Grid>;
};
